import { Button, Form, Input, Select, message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import {
  AppLevelConfigPayload,
  getAllAppSourceConfig,
  saveAppSourceConfig,
  getSourceAppNames,
  MstRequest,
  SourceAppNamelist,
  getMasterConfigDetails,
  ConfigNamelist,
} from 'api/master';
import { FileExcelFilled } from '@ant-design/icons';
//import { Modal } from 'antd';
import Applevellist from '../Applevellist';
import xlsx from 'json-as-xlsx';
import moment from 'moment';

//const applevelconfigPayload: AppLevelConfigPayload = {};
const mstRequest: MstRequest = {};

const Filter = () => {
  const { Option } = Select;

  const [form] = Form.useForm<AppLevelConfigPayload>();
  //const [inputValue, setInputValue] = useState('');
  const [filter, setFilter] = useState(mstRequest);
  const [sourceAppNames, setSourceAppNames] = useState<SourceAppNamelist[]>([]); // State to hold dropdown options4
  const [configNames, setConfigNames] = useState<ConfigNamelist[]>([]);
  const [selectedService, setSelectedService] = useState<string>('');
  const [selectedServiceDescription, setSelectedServiceDescription] = useState<string>('');
  const [selectedConfigValueDescription, setSelectedConfigValueDescription] = useState<string>('');

  const isAdmin = sessionStorage.getItem('isAdmin');
  useEffect(() => {
    fetchSourceAppNames();
  }, []);

  const fetchSourceAppNames = async () => {
    try {
      debugger;
      mstRequest.userName = sessionStorage.getItem('user')?.toString();
      mstRequest.isActive = true;
      mstRequest.pageNo = 0;
      mstRequest.pageSize = 0;
      mstRequest.roleId = '';

      const response = await getSourceAppNames(mstRequest);
      setSourceAppNames(response.data);
      const res = await getMasterConfigDetails(mstRequest);
      setConfigNames(res.data);
    } catch (error) {
      console.error('Error fetching source application names:', error); // Log any errors
    }
  };

  const handleServiceChange = useCallback((value: string) => {
    setSelectedService(value);
  }, []);

  const validateInput = (_: any, value: string) => {
    if (value && parseInt(value) > 744) {
      return Promise.reject(new Error('Configuration value should not more than 744 hrs'));
    }
    return Promise.resolve();
  };

  useEffect(() => {
    const selectedConfig = configNames.find((config) => config.name === selectedService);
    if (selectedConfig) {
      setSelectedServiceDescription(selectedConfig.configDesc || '');
      setSelectedConfigValueDescription(selectedConfig.valueDesc || '');
    } else {
      setSelectedServiceDescription('');
      setSelectedConfigValueDescription('');
    }
  }, [selectedService, configNames]);

  function getFullDate(date: string, format = 'DD/MM/YYYY HH:mm:ss') {
    if (date != null) {
      const dateMoment = moment(new Date(date)).format(format);
      return dateMoment;
    }
  }

  function handleDownload(_e: any) {
    debugger;
    //filter.pageNo = -1;
    filter.isExtract = true;
    // getAllAppSourceConfig(filter).then((_x) => {
    //     const csvConfig = {
    //         useKeysAsHeaders: true,
    //         filename: 'ApplicationLevel-Report.csv'
    //     };
    //     const csvData = generateCsv(csvConfig)(_x.data.data);
    //     download(csvConfig)(csvData);
    // });

    getAllAppSourceConfig(filter).then((_x) => {
      //   console.log('service source mapping ', _x);
      let settings = {
        fileName: 'ApplicationLevel-Report',
        extraLength: 3,
        writeMode: 'writeFile',
        writeOptions: {},
        RTL: false,
      };

      const sortedData =
        _x.data?.data.sort((a: any, b: any) => {
          return b.id - a.id;
        }) || [];
      const updatedData = sortedData.map((item: any, index) => ({
        ...item,
        createdOn: getFullDate(item.createdOn),
        ROWNUM: index + 1,
      }));

      let data = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'ROWNUM', value: 'ROWNUM' },
            { label: 'id', value: 'id' },
            { label: 'sourceId', value: 'sourceId' },
            { label: 'configKey', value: 'configKey' },
            { label: 'configValue', value: 'configValue' },
            { label: 'createdOn', value: 'createdOn' },
            { label: 'createdBy', value: 'createdBy' },
            { label: 'flag', value: 'flag' },
            { label: 'totalCount', value: 'totalCount' },
            { label: 'sourceApplicationName', value: 'sourceApplicationName' },
          ],
          content: updatedData,
        },
      ];
      xlsx(data, settings);
    });
  }

  const handleSubmit = useCallback(
    async (values: AppLevelConfigPayload) => {
      try {
        let finalConfigValue = 0;

        // Convert minutes to hours and add to the hours value
        if (values.configValueHours) {
          finalConfigValue += parseFloat(values.configValueHours);
        }
        if (values.configValueMinutes) {
          finalConfigValue += parseFloat(values.configValueMinutes) / 60;
        }

        // Update the payload with the combined value
        const payloadToSend = {
          ...values,
          configValue: finalConfigValue.toString(),
        };

        debugger;
        payloadToSend.createdBy = sessionStorage.getItem('user')?.toString();
        payloadToSend.flag = true;
        payloadToSend.sourceApplicationName = '';
        payloadToSend.createdOn = '';

        await saveAppSourceConfig(payloadToSend);
        form.resetFields();
        setFilter({});
        message.success('Configuration saved successfully.');
        window.location.reload();
      } catch (error) {
        console.error('Error saving configuration:', error);
        message.error('Failed to save configuration. Please try again.');
      }
    },
    [form]
  );

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = mstRequest;
    setFilter(updatedFilter);
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Application Level Link Expiry Configuration</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form<AppLevelConfigPayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  initialValues={{
                    ['Username']: sessionStorage.getItem('user')?.toString(),
                    ['sourceApplicationName']:
                      isAdmin != 'true' ? sessionStorage.getItem('source')?.toString() : null,
                  }}
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div>
                        <Form.Item label={'Source Application Name:'}></Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          //label={'Source Application Name:'}
                          name="sourceId"
                          className="fieldTitle"
                          rules={[
                            { required: true, message: 'Please select source application name.' },
                          ]}
                        >
                          <Select placeholder="Select" size="large">
                            {sourceAppNames.map((app) => (
                              <Option key={app.sourceId} value={app.sourceId}>
                                {app.sourceApplicationName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div>
                        <Form.Item label={'Configuration Name :'}></Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          //label={'Configuration Name :'}
                          name="configKey"
                          className="fieldTitle"
                          rules={[{ required: true, message: 'Please select configuration name.' }]}
                        >
                          <Select placeholder="Select" size="large" onChange={handleServiceChange}>
                            {configNames.map((app) => (
                              <Option key={app.name} value={app.code}>
                                {app.code}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        {selectedServiceDescription && (
                          <span style={{ color: 'red' }}>{selectedServiceDescription}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div>
                        <Form.Item label={'Configuration Value :'}></Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-8 col-md-8">
                      <div className="input-box">
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <Form.Item
                            name="configValueHours"
                            className="fieldTitle"
                            style={{ flex: 1 }}
                            rules={[
                              {
                                validator: validateInput,
                              },
                            ]}
                          >
                            <Input placeholder={'In Hrs'} />
                          </Form.Item>
                          <Form.Item
                            name="configValueMinutes"
                            className="fieldTitle"
                            style={{ flex: 1 }}
                          >
                            <Input placeholder={'In Mins'} />
                          </Form.Item>
                        </div>
                        {selectedConfigValueDescription && (
                          <span style={{ color: 'red' }}>{selectedConfigValueDescription}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="payment-button">
                      <Button
                        id="btnClear"
                        className="proceed-btn"
                        size="small"
                        style={{ height: '40px', width: '100px', marginBottom: '10px' }}
                        onClick={handleReset}
                      >
                        CLEAR
                      </Button>
                      &nbsp;&nbsp;
                      <Button
                        id="btnSubmit"
                        className="proceed-btn"
                        size="small"
                        style={{ height: '40px', width: '100px', marginBottom: '10px' }}
                        onClick={() => form.submit()}
                      >
                        SAVE
                      </Button>
                      <Button
                        type="link"
                        icon={<FileExcelFilled />}
                        style={{ float: 'right', fontSize: '30px', color: 'green' }}
                        onClick={handleDownload}
                      ></Button>
                    </div>
                  </div>
                </Form>
              </div>
              <Applevellist filter={{ ...filter }} onSubmit={handleSubmit} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
